import React, { Component } from 'react';
import logo from '../img/logo.jpg';
import blueSeal from '../img/blue-seal-150-110-bbb-87138499.png';
import Axios from '../config/axios';

import { FaEnvelope, FaPhone } from 'react-icons/fa';

import NumberFormat from 'react-number-format';
import { NotificationContainer, NotificationManager } from 'react-notifications';
import 'react-notifications/lib/notifications.css';

//import { ToastContainer, toast } from 'react-toastify';
//import 'react-toastify/dist/ReactToastify.css';

import ReactLoading from 'react-loading';

export class Home extends Component {
    constructor(props) {
        super(props);

        this.state = {
            formFields: {
                contactEmail: "",
                contactName: "",
                contactPhone: "",
                contactContent: "",
                contactCompany: ""
            },
            loading: false,
            disabled: true
        }

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.notifySuccess = this.notifySuccess.bind(this);
        this.notifyFail = this.notifyFail.bind(this);
    }

    notifyFail(string) {
        NotificationManager.error(string, 'Something went wrong');
    }
    notifySuccess() {
        NotificationManager.success('Thank you for reaching out! I will be in touch with you shortly.', 'Success');
    }

    handleInputChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({ formFields: { ...this.state.formFields, [name]: value } });
    }

    handleSubmit() {
        let postdata = {};

        postdata.name = this.state.formFields.contactName;
        postdata.email = this.state.formFields.contactEmail;
        postdata.content = this.state.formFields.contactContent;
        postdata.phone = this.state.formFields.contactPhone;
        postdata.company = this.state.formFields.contactCompany;
        
        if (postdata.name === "" ||
            postdata.email === "" ||
            postdata.phone === "" ||
            postdata.content === "" ||
            postdata.company === "") {
            this.notifyFail('Please make sure all fields are filled out.');
        } else {
            this.setState({
                loading: true
            });


            Axios.post(`/api/Contact`, postdata
            ).then(response => {
                if (response.data === true) {
                    this.notifySuccess();
                    let ffCopy = this.state.formFields;
                    ffCopy.contactContent = "";
                    ffCopy.contactEmail = "";
                    ffCopy.contactName = "";
                    ffCopy.contactPhone = "";
                    ffCopy.contactCompany = "";
                    this.setState({
                        formFields: ffCopy,
                        loading: false
                    });
                } else {
                    this.notifyFail('Whoops, something went wrong. Please reach out directly to me at kim@mspipellc.com.');
                    this.setState({
                        loading: false
                    });
                }
            }).catch(error => {
                this.notifyFail('Whoops, something went wrong. Please reach out directly to me at kim@mspipellc.com.');
                this.setState({
                    loading: false
                });
                console.log(error);
            });
        }


    }

    render() {
        return (
            <div className="container">
                <NotificationContainer />
                <div className="row custRow">

                    <div className="col-lg-3 col-sm-12 col-xs-12">
                        <img src={logo} className="img-responsive rcenter" alt="" /> </div>


                    <div className="col-lg-6 col-sm-6 col-xs-12 header">
                        <span className="mission"><span className="noWrap">Supplier of Pipe, </span> <span className="noWrap">Fittings, </span> <span className="noWrap">Valves, &amp; Accesories</span></span><br />
                        <span className="subHeader">Serving:</span>&nbsp;CT, MA & RI
</div>

                    <div className="col-lg-3 col-sm-6 col-xs-12 text-right contactText">
                        <span className="contactTextBig">MS. PIPE, LLC</span><br />

                        49 OAKLAND RD <br />
                        P.O. BOX 1295 <br />
                        SOUTH WINDSOR CT 06074 <br />
                        (P) 860-644-7070<br />
                        (F) 860-644-7373<br />
                        <span className="fontSize22 contactTextBig fontWeight600"><a href="mailto:kim@mspipellc.com" className="colorPink">kim@mspipellc.com</a></span> <br />

                    </div>





                    <p></p>
                </div>
                <div className="row">

                    <div className="col-lg-8 col-md-8 col-sm-8 col-xs-12 marginTop10">
                        <h2>Your Partner in Excellence</h2>
                        <p>

                            Ms Pipe LLC was established in 2005 & is a 100% Woman Owned Business.  Ms Pipe, LLC is a certified WBE in CT, MA, & RI. <br /><br />
                            Ms. Pipe, LLC specializes in supplying Ductile Iron Pipe, Fittings, Valves, and Misc Accessories for the Water/Wastewater Treatment Industry.  Ms. Pipe LLC also supplies PVC, HDPE, SS, and other items used in construction. <br /><br />
                            Ms. Pipe, LLC takes pride in building long lasting business relationships through our 20 years of experience in the Waterworks Industry and providing excellent customer service. <br /><br />
                            Ms Pipe, LLC can supply construction materials & also fulfill your WBE requirements. <br /><br />
                            Thank you for choosing Ms. Pipe, LLC for your construction needs,<br />
                            <br />
                            <strong className="pinkItalics">Kimberly A. Cadorette, Owner</strong> </p>
                    </div>



                    <div className="col-lg-4 col-md-4 col-sm-4 col-xs-12 contactForm">
                        <p></p>
                        <div>
                            <div className="form-group">
                                <input type="text" className="form-control" id="" placeholder="Your Name" name="contactName" value={this.state.formFields.contactName} onChange={this.handleInputChange} />
                            </div>
                            <div className="form-group">
                                <input type="text" className="form-control" id="" placeholder="Company Name" name="contactCompany" value={this.state.formFields.contactCompany} onChange={this.handleInputChange} />
                            </div>
                            <div className="input-group form-group">

                                <span className="input-group-addon glyphicon glyphicon-envelope" id=""><FaEnvelope /></span> <input type="email" className="form-control" id="" placeholder="Your Email" name="contactEmail" value={this.state.formFields.contactEmail} onChange={this.handleInputChange} />
                            </div>

                            <div className="input-group form-group">

                                <span className="input-group-addon glyphicon glyphicon-phone-alt" id=""><FaPhone /></span> <NumberFormat className="form-control" name="contactPhone" value={this.state.formFields.contactPhone} onChange={this.handleInputChange} format="(###) ###-####" placeholder="Phone Number" />
                            </div>
                            <div className="form-group message">
                                <textarea className="form-control" rows="6" id="message" placeholder="Type your comments or questions here..." name="contactContent" value={this.state.formFields.contactContent} onChange={this.handleInputChange}></textarea>
                            </div>

                            <div>
                            <button className="btn btn-default colorBlack" onClick={this.handleSubmit}>Submit</button>
                            {this.state.loading &&
                                <span><ReactLoading className='tableLoading' type={"spokes"} color={'#FFC0CB'} height={30} width={30} /></span>
                                }
                            </div>
                        </div>

                    </div>


                </div>

            </div>
        );
    }
}
